/* eslint-disable react-hooks/exhaustive-deps */
import Axios from 'axios';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { SelectButton } from 'primereact/selectbutton';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomRouter from 'src/hooks/useCustomRouter';
import useLoading from 'src/hooks/useLoading';
import usePageValidation from 'src/hooks/usePageValidation';
import { setCotizacion } from 'src/reducers/Cotizacion/cotizacion.actions';
import { OPCIONES_PAGO } from 'src/reducers/Cotizacion/cotizacion.reducer';
import usePaginaCompra from 'src/reducers/PaginaCompra/usePaginaCompra';
import { guardarLead } from 'src/services';
import { urlSetBeneficiarios, urlUpdateCotizacionById } from 'src/services/urls';
import { scrollTop } from 'src/utils/functiones';
import uuid from 'uuid';
import CheckBeneficiarioIgualTitular from '../CheckBeneficiarioIgualTitular';
import EditarVigencia from '../EditarVigencia';
import Cetificado from 'src/components/CargaDescargaCertificado'
import useQueryString from 'src/hooks/useQueryString';

import Listado from '../Listado';
import '../styles.css';
import Impuestos from '../../PaginaPago/Impuestos';
import useCustomToast from 'src/hooks/useCustomToast';

const TAG = 'paginaResumen'

const PaginaResumen = () => {
  const methods = useForm({ mode: 'onChange', reValidateMode: 'onChange', shouldUnregister: false });
  const [disabledButton, setDisabledButton] = useState(false)
  const { cotizacion, idCotizacion } = useCotizacion();
  const { execEvent, isLoadingCallbacks } = usePageValidation(TAG);
  const { reset, formState: { errors, isValid, isDirty } } = methods;
  const { setShowForm, editarBeneficiario, indexEditar } = usePaginaCompra();
  const { addErrorToast } = useCustomToast()

  const camposKey = useMemo(() => cotizacion.beneficiarioIgualTitularChecked ? 'camposTitular' : 'camposBeneficiarios', [cotizacion.beneficiarioIgualTitularChecked]);
  const loadingPageProps = useLoading(false);
  const loaderBeneficiarios = useLoading();
  const qparams = useQueryString()

  const {
    values: valuesLoadingBeneficiarios,
    setLoading: setLoadingBeneficiarios,
    resetLoading: resetLoadingBeneficiarios,
    setSecundario: setSecundarioBeneficiarios,
  } = loaderBeneficiarios;
  const textos = cotizacion?.configuracion?.textos?.paginaResumen

  const [pageProps, setPageProps1] = useState({
    labelPagar: 'Total a pagar: ',
    pathValuePagar: 'valoresPagar.total',
    hideLabelPagar: false,
    customLabelPagar: null,
    goBack: `/newRegistro/${cotizacion?.idCotizacion}`,
    showTitular: true,
    showBeneficiarios: true, // sirve para ocultar beneficiarios
    footerButtonContinuar: {
      label: 'Continuar',
      className: 'footer_button__continuar',
      classNameContainer: 'footer_container__continuar',
    },
    loaderBeneficiarios,
    loadingPageProps,
    subheader: {
      titulo: `Resumen de datos.`,
      subtitulo: 'Por favor revise la información ingresada.'
    },
    camposBeneficiarios: undefined,
    btnOpciones: [],
    btnOpcionesShow: false,
    fnBtnOpciones: (_props) => { },
    impuestos: [],
    showCertificado: false,
    alert: null
  });

  const setPageProps = (value) => {
    setPageProps1(value)
  }
  const history = useCustomRouter();
  const dispatch = useDispatch();
  const init = async () => {
    const labelBeneficiarioBien = cotizacion?.producto?.categoria?.CamposBeneficiariosInfo?.labelBeneficiarioBien ?? ''
    if (labelBeneficiarioBien)
      setPageProps1(prev => ({
        ...prev, subheader: {
          ...prev.subheader, tituloText: `Ingreso de datos de ${labelBeneficiarioBien}`,
          descripcionText: 'Por favor ingrese la siguiente información de ' + labelBeneficiarioBien + ' que quieres agregar.'
        }
      }))
    scrollTop();

    if (cotizacion.beneficiarios.length > 0) {
      const beneficiario = cotizacion.beneficiarios[0];
      reset({ ...beneficiario });
      editarBeneficiario(beneficiario, 0);
    }
    if(cotizacion?.cambioTerritorio){
      setLoadingBeneficiarios(true);
      let body = {
        beneficiarios: cotizacion.beneficiarios,
        idCotizacion,
      };
      let {data} = await Axios.post(urlSetBeneficiarios, JSON.stringify(body))
      dispatch(setCotizacion(data.cotizacion));
      setLoadingBeneficiarios(false);
    }
   /* ;*/
    execEvent('initCallback', { formMethods: methods, pageProps, setPageProps, setShowForm }, async () => {

      if (cotizacion?.producto?.firmaFisica === '1') {
        setPageProps({
          ...pageProps,
          showCertificado: true
        })
      }
    });
  };
  useEffect(() => {
    guardarLead(idCotizacion, `PAGINA_COMPRA__INGRESO`);
  }, [])

  useEffect(() => {
    init();
    
    if (isLoadingCallbacks) return;
    return () => {
      editarBeneficiario(null, null);
      execEvent('out');
    };
  }, [isLoadingCallbacks]);

  const desabilitarBoton = () => {
    setDisabledButton(true)
    setTimeout(() => setDisabledButton(false), 2000)
  }

  const onSubmit = async (dataform, indexedit = false, certificado = false) => {

    desabilitarBoton();
    let data = {}

    for (const property in dataform) {
      if (typeof dataform[property] === "string")
        data[property] = dataform[property].trim();
      else data[property] = dataform[property];
    }
    guardarLead(idCotizacion, `PAGINA_COMPRA__CLICK_GUARDAR_DATOS`);
    execEvent('onClickGuardarCallback', { data, pageProps, setPageProps }, async () => {

      setLoadingBeneficiarios(true);
      setSecundarioBeneficiarios('Guardando información...');

      if (indexedit) {
        cotizacion.beneficiarios[0] = { ...cotizacion.beneficiarios[0], ...data }
      } else if (indexEditar !== null) {
        cotizacion.beneficiarios[indexEditar] = data;
        editarBeneficiario(null, null);
      } else {
        if (!cotizacion?.beneficarios) {
          cotizacion.beneficarios = [];
        }
        cotizacion.beneficiarios.push(data);
      }

      let body = {
        beneficiarios: cotizacion.beneficiarios,
        idCotizacion,
      };
      guardarLead(idCotizacion, 'REGISTRO_BENEFICIARIOS_RESUMEN');
      // Axios.get(urlcalcularVigenciaPoliza(idCotizacion)).catch((e) => { });
      let { data: response } = await Axios.post(urlSetBeneficiarios, JSON.stringify(body));
      if (response.transaccion) {
        if (pageProps?.showCertificado && certificado) {
          const url = urlUpdateCotizacionById()
          const { data: res } = await Axios.post(url, { idCotizacion, estadoCliente: 'SS' });
          response.cotizacion = { ...response.cotizacion, ...res.cotizacion }
          guardarLead(idCotizacion, 'REGISTRO_BENEFICIARIOS_RESUMEN');
          // dispatch(setCotizacion(res.cotizacion))

        }
        const callbackProps = { pageProps, setPageProps, responseData: response };

        await execEvent('dispatchCotizacionSetBeneficiarios', callbackProps, () => {
          dispatch(setCotizacion(response.cotizacion));

        }
        );
      }

      resetLoadingBeneficiarios();
      methods.reset();
    });
  };

  const onClickContinuar = async () => {
    if(validarTotal()){
    console.log("beneficiario ingresa")
    guardarLead(idCotizacion, `PAGINA_COMPRA__CLICK_CONTINUAR`);
    execEvent('onClickContinuarCallback', { pageProps, setPageProps }, async (retorno) => {
      guardarLead(idCotizacion, `PAGINA_COMPRA__CLICK_CONTINUAR`);
      if (cotizacion.opcionPago === OPCIONES_PAGO.SELECCIONAR) {
        return history.push(`/paginaPago/${idCotizacion}`);
      }
      else
        if (`${cotizacion.producto.tieneFirma}` === '1') {
          switch (cotizacion.medioFirma) {
            case 'evicertia': return history.push(`/firmarCertificado/${idCotizacion}`);
            case 'fisica': return history.push(`/ingresarPoliza/${idCotizacion}/`);
            case 'token': return history.push(`/verificarTokenPago/${idCotizacion}/${idCotizacion}`);
            default:
              // addErrorToast('Cotizacion no tiene el medio para la firma', { autoDismiss: false });
              break;
          }
        } else {
          return history.push(`/ingresarPoliza/${idCotizacion}/`);
        }
    })
    }else{
      addErrorToast('La Cotización no tiene total a pagar', { autoDismiss: false });
    }
  };

  const onClickAgregar = () => {
    guardarLead(idCotizacion, `PAGINA_COMPRA__CLICK_AGREGAR`);
    history.push(`/newPaginaCompra/${idCotizacion}?index=${cotizacion?.beneficiarios?.length ?? 0}`);
  };

  const seleccionOpciones = (value) => {
    if (value.length > 0)
      pageProps.fnBtnOpciones({ value: value[value.length - 1] })
  }

  const validarTotal = () =>{
    let flag = true;
    let total =_.get(
      cotizacion,
      pageProps.pathValuePagar, 
      ''
    );
    if(total === 0 || total === '' || total === null){
      flag = false;
    }

    return flag;
  }
  const { showBeneficiarios = true } = pageProps

  return (
    <LoadingWrapper {...loadingPageProps.values}>
      <DIV stylePath="paginaCompra.globalStyles" className="container-fluid container-page">
        <NavbarHeader goBack={pageProps?.goBack} />
        <HeaderPage progreso={60} />
        <LoadingWrapper {...valuesLoadingBeneficiarios} height="80%">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-7 mt-3">
              <h4 className="titulo font-weight-bold">
                {((textos?.titulo || pageProps?.subheader?.titulo) ?? '')}
              </h4>
              <p className="descripcion">
                {(textos?.subtitulo || (pageProps?.subheader?.subtitulo ?? ''))}
              </p>
              {console.log("_.get(cotizacion, pageProps.pathValuePagar, '')", pageProps.customLabelPagar)}
              {!pageProps?.hideLabelPagar && (
                <h6 className="total__pagar text-primary font-weight-bold text-center">
                  <span className="text-dark">{pageProps?.labelPagar} </span> {cotizacion?.moneda?.signo}
                  {_.get(cotizacion, pageProps.pathValuePagar, '')} {cotizacion?.moneda?.sigla} {['Indefinido', 'mensual'].find(e => e === cotizacion?.producto?.periocidadPago) && 'mensuales'}
                </h6>
              )}
              {pageProps.customLabelPagar}
              <Impuestos impuestos={pageProps.impuestos} moneda={cotizacion?.moneda} />
            </div>
          </div>
          <EditarVigencia cotizacion={cotizacion} />
          <FormProvider {...methods}>

            {pageProps.alert &&
              <div className="row justify-content-center pb-3">
                <div className="col-11 col-md-10 col-lg-7 mt-2">
                  {pageProps.alert}
                </div>
              </div>
            }
            {<>
              {cotizacion?.titularAgrupacion && pageProps.showTitular && (
                <>
                  <div className="row mt-3 justify-content-center">
                    <div
                      className="col-11 col-md-10 col-lg-8 col-xl-7 my-3"
                      style={{ border: 'solid 1px #979797', height: '1px' }}
                    />
                  </div>
                  <div className="container__bienes__list row justify-content-center">
                    <Listado
                      data={[cotizacion?.titularAgrupacion]}
                      camposKey="camposTitular"
                      showDelete={false}
                      isTitular={true}
                    />
                  </div>
                </>
              )}
              {showBeneficiarios && <>
                {!cotizacion?.beneficiarioIgualTitularChecked && (
                  cotizacion?.beneficiariosAgrupacion.map((item, index) => {
                    return <div className="container__bienes__list row justify-content-center mt-3" key={index}>
                      <Listado
                        data={[item]}
                        camposKey={camposKey}
                        index={(index)}
                      />
                    </div>
                  }
                  )
                )}
                {cotizacion.beneficiarios.length < parseInt(cotizacion.producto.numBeneficiarios) &&
                  !cotizacion.beneficiarioIgualTitularChecked && (
                    <div className="row justify-content-center pb-3">
                      <div className="col-11 col-md-10 col-lg-8 col-xl-7">
                        <strong className="btn btn-primary " onClick={onClickAgregar}>
                          {'+ Agregar otro ' + cotizacion?.producto?.categoria?.CamposBeneficiariosInfo?.labelBeneficiarioBien}
                        </strong>
                      </div>
                    </div>
                  )}
              </>}

              {pageProps.btnOpcionesShow &&
                <div className="row justify-content-center mt-2 pb-3">
                  <SelectButton className="footer_container__continuar text-center" options={pageProps?.btnOpciones} onChange={(e) => seleccionOpciones(e.value)} optionLabel="name" multiple />
                </div>
              }
            </>
            }
          </FormProvider>

          {pageProps.showCertificado &&
            <div className="row justify-content-center" style={{ padding: '3rem 0px' }}>
              <div className="col-11 col-md-10 col-lg-8 col-xl-7">
                <Cetificado submit={data => onSubmit(data, true, true)} />
              </div>
            </div>
          }
        </LoadingWrapper>

        {
          ((!pageProps.btnOpcionesShow) && (!pageProps.showCertificado || cotizacion?.estadoCliente === 'SS')) && (
            <FooterButton
              label="Continuar"
              onClick={onClickContinuar}
              className="footer_button__continuar"
              classNameContainer="footer_container__continuar"
              disabled={valuesLoadingBeneficiarios.loading || disabledButton}
              {...pageProps.footerButtonContinuar}
            />
          )
        }
      </DIV >
    </LoadingWrapper >
  );
};

export default withCotizacion(PaginaResumen);

// const GET_VALUES = (item) => item?.split("|")[0]; 
// const initCallback = async (resources) => 
// { const { pageProps, setPageProps, dispatch, redux, setCotizacion, idCotizacion, history, guardarLead, toasts, inputsResources, urls, Axios, } = resources;
//  const { cotizacion } = redux.getState()?.["Cotizacion"];
//  const onClickContinuar = () => { guardarLead(idCotizacion, `PAGINA_COMPRA__CLICK_CONTINUAR`);
//  const { cotizacion } = redux.getState()?.["Cotizacion"];
//  if (cotizacion?.valoresPagar?.transaccion === false) { return toasts.addWarningToast(cotizacion?.valoresPagar?.errorDescripcion || "Por favor actualice los datos");
//  } return history.push(`/newRegistro/${idCotizacion}`);
//  };
//  setPageProps({ ...pageProps, goBack: `/preview/${idCotizacion}/${cotizacion?.producto?.id}`, showTitular: false, footerButtonContinuar: { ...pageProps?.footerButtonContinuar, onClick: onClickContinuar, }, });
//  try { cotizacion.producto.categoria.camposBeneficiarios = cotizacion?.producto?.categoria?.camposBeneficiarios?.filter?.((item) => item?.codCore !== "información");
//  } catch (error) { cotizacion.producto.categoria.camposBeneficiarios = [];
//    toasts.addWarningToast("Ha ocurrido un problema en la ejecución del callback");
//  } if (cotizacion?.beneficiarios?.length > 0) { const beneficiario = cotizacion.beneficiarios[0];
//    const url = `${urls?.URL_PLUGIN_FRONTEND}combo/anio-ecuaprimas&empresa=ecuaprimastest&marca=${GET_VALUES(beneficiario.marca)}&modelo=${GET_VALUES(beneficiario.modelo)}`;
//  const { data } = await Axios.post(url);
//  inputsResources.setResources({ ...inputsResources.state, anio: data?.data, });
//  } dispatch(setCotizacion(cotizacion));
//  return { continue: true };
//  }; initCallback;